import React from "react";
import { useNavigate } from "react-router-dom";
import { ForgotPasswordForm } from "../components/auth";
import authImage from "../assets/auth-login-image.png";
import appLogo from "../../public/img/logo/Blue_logo.png";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();

  const handleResetSuccess = () => {
    // Show success message and redirect to login
    navigate("/login");
  };

  const handleResetError = (error: Error) => {
    console.error("Password reset error:", error);
    // Additional error handling can be added here
  };

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Left Side Image Section */}
      <div className="hidden md:block w-1/2 overflow-hidden">
        <img
          src={authImage}
          alt="Illustration"
          className="object-cover h-screen w-full p-4 rounded-3xl"
        />
      </div>
      {/* Right Side Form Section */}
      <div className="flex flex-col justify-center items-center w-full md:w-1/2 px-8 py-12">
        <div className="w-full max-w-xl">
          <img src={appLogo} width={150} alt="logo" className="mb-4" />

          <h2 className="text-3xl font-bold mb-0 text-gray-900">
            Welcome to <span className="text-primary-button">Medicare AI</span>
          </h2>
          <p className="text-gray-600 text-sm mb-8">
            Forgot your password? We’ll help you get back on track.
          </p>
          <ForgotPasswordForm
            onSuccess={handleResetSuccess}
            onError={handleResetError}
          />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
